import React, { useEffect, useMemo, useRef, useState} from 'react'
import {Popup} from 'devextreme-react/popup'
import Form, {
    ButtonItem,
    ButtonOptions,
    GroupItem,
    Item,
    Label, PatternRule,
    RangeRule,
    RequiredRule,
    SimpleItem,
    StringLengthRule,
} from 'devextreme-react/form'
import 'devextreme-react/text-area'
import 'devextreme-react/file-uploader'
import {useReqPopup} from '../../contexts/req-popup'
import {useAuth} from '../../contexts/auth'
import './request-popup.scss'
import {sendLettersMailRequest, sendUserRequest} from '../../api/request'
import notify from 'devextreme/ui/notify'
import LoadIndicator from 'devextreme-react/load-indicator'
import ScrollView from 'devextreme-react/scroll-view'
import {getPointsList} from '../../api/dogovor'
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faPenClip} from "@fortawesome/free-solid-svg-icons";
import {getPointPus} from '../../api/point'
import ExtFileUploader from "../file-uploader/file-uploader";
import MessageCompositeField from './message-composite-field'
import {useScreenSize} from "../../utils/media-query";
/** Подсказка для запроса на смену адреса (тип 2) */
const ADDRESS_CHANGE_HINT = 'впишите сюда причину смены адреса'
const ADDRESS_CHANGE_HINT_PATTERN = /<\s*причина изменения\s*>|впишите сюда причину смены адреса/gi

function splitAddressChangeMessage(message) {
    if (!message) return null
    const hintMatch = message.match(ADDRESS_CHANGE_HINT_PATTERN)
    if (!hintMatch) return null

    const hintIndex = message.search(ADDRESS_CHANGE_HINT_PATTERN)
    if (hintIndex < 0) return null

    const prefix = message.slice(0, hintIndex)
    const suffix = message.slice(hintIndex + hintMatch[0].length)
    if (!prefix.trim()) return null

    return { prefix, suffix }
}

function buildAddressChangeMessage(prefix, body, suffix) {
    return `${prefix}${body}${suffix || ''}`
}

// заменим дефолтный текст реквизитами
function parseMessage(message, selectedDog) {
    if (!message) return null
    let res = message
    if (res.indexOf('<укажите ИНН>') && selectedDog) {
        res = res.replace('<укажите ИНН>', 'ИНН '+selectedDog.inn)
    }
    if (res.indexOf('<укажите номер договора>') && selectedDog) {
        res = res.replace('<укажите номер договора>', selectedDog.ndog)
    }
    if (res.indexOf('<укажите название организации>') && selectedDog) {
        res = res.replace('<укажите название организации>', selectedDog.name)
    }
    res = res.replace(/<\s*причина изменения\s*>/gi, ADDRESS_CHANGE_HINT)
    return res
}

/** Типы для свободного выбора в селекте: visible с бэка; текущий тип — всегда, если открыли из раздела */
function getSelectableRequestTypes(reqTypes, currentTypeId) {
    return (reqTypes || []).filter(
        (type) => type.visible === 1 || type.visible === true || type.id === currentTypeId
    )
}


const RequestPopup = () => {

    const { isOpen, defaultType, setDefaultType, defaultMessage, setDefaultMessage, openReqPopup,
        dogVisibleTypes, pointVisibleTypes, tuList, setTuList, selectedTu, setSelectedTu, disabledTypes, pu, setPu, typeFileLimit, setSendMessage } = useReqPopup()
    const {reqTypes, lettersCount, setLettersCount, selectedDog } = useAuth()
    const formData = useRef({})
    const [loading, setLoading] = useState(false)
    const [addressChangeBody, setAddressChangeBody] = useState('')
    const pointDisabled = false
    const extFileUploaderRef = useRef();
    const { isXSmall } = useScreenSize();

    const parsedDefaultMessage = useMemo(
        () => parseMessage(defaultMessage, selectedDog),
        [defaultMessage, selectedDog]
    )
    const addressChangeParts = useMemo(
        () => (defaultType === 2 ? splitAddressChangeMessage(parsedDefaultMessage) : null),
        [defaultType, parsedDefaultMessage]
    )
    const useCompositeMessage = Boolean(addressChangeParts)

    useEffect(() => {
        if (!isOpen) return

        setAddressChangeBody('')
        formData.current.message = useCompositeMessage ? '' : parsedDefaultMessage
    }, [isOpen, defaultMessage, defaultType, selectedDog, useCompositeMessage, parsedDefaultMessage])

    const onAddressChangeBodyChanged = (value) => {
        setAddressChangeBody(value)
        formData.current.message = value
    }

    function hidingPopup() {
        setSendMessage(false)
        formData.current.message = undefined
        setAddressChangeBody('')
        openReqPopup(false, null)
    }

    const onSendRequest = async (e) => {
        e.preventDefault();

        const { point, message, attachments,
            nom_pu, name_typepu, dat_s, razr1, razr2, god_vip, kvartal_pp,
            god_pp, balance_name, expl_name, dat_start_w, dat_end_w, mpi } = formData.current;

        const requestMessage = useCompositeMessage && addressChangeParts
            ? buildAddressChangeMessage(addressChangeParts.prefix, message?.trim() || '', addressChangeParts.suffix)
            : message

        if (useCompositeMessage) {
            const reason = addressChangeBody?.trim()
            if (!reason || reason === ADDRESS_CHANGE_HINT) {
                notify('Укажите причину смены адреса', 'error', 5000)
                return
            }
        }

        //region ext
        const fd = new FormData()
        fd.append('typeText',reqTypes.find(type=> type.id === defaultType).name)
        fd.append('message', requestMessage)
        fd.append('type',defaultType)//type_request
        //если в заявке обязательные документы
        if ([1,5,7].includes(defaultType) && (attachments === undefined || attachments?.length === 0)) {
            notify('Прикрепите соотвествующий(е) документ(ы)!','error', 5000)
            return
        }

        //если в заявке участвует договор
        if (selectedDog /*&& dogVisibleTypes.includes(defaultType)*/) fd.append('kod_dog',selectedDog.kodDog)
        if (selectedDog /*&& dogVisibleTypes.includes(defaultType)*/) fd.append('ndog',selectedDog.ndog)
        //если в заявке участвует точка учета
        if (selectedDog && pointVisibleTypes.includes(defaultType)) fd.append('point',point)
        if (selectedDog && pointVisibleTypes.includes(defaultType)) {
            const pointName = tuList.filter(tu => tu.kodPoint === point)[0].text
            fd.append('point_name',pointName)
        }
        //если подаем заявку на замену ПУ
        if (selectedDog && defaultType === 5) {
            if (god_vip > god_pp) {
                notify('Год выпуска не может быть больше года ПП!', 'error', 5000)
                return
            }
            fd.append('nom_pu', nom_pu)
            fd.append('name_typepu', name_typepu)
            fd.append('dat_s', dat_s)
            fd.append('razr1', razr1)
            fd.append('razr2', razr2)
            fd.append('god_vip', god_vip)
            fd.append('kvartal_pp', kvartal_pp)
            fd.append('god_pp', god_pp)
            fd.append('balance_name', balance_name)
            fd.append('expl_name', expl_name)
            fd.append('dat_start_w', dat_start_w)
            fd.append('dat_end_w', dat_end_w)
            fd.append('mpi', mpi)
        }

        for (let i=0; i<attachments?.length; i++) {
            fd.append('file',attachments[i])
        }
        setLoading(true);

        const result = await sendUserRequest(fd)
        if (result.isOk) {
            //если успешно создали заявку
            openReqPopup(false);
            notify(result.message, 'success', 5000);
            setLettersCount(lettersCount + 1);
            extFileUploaderRef.current.clearAttachFiles();
            formData.current.attachments = undefined;
            setSendMessage(true);

            //#region отмыливаем заявку
            const resultMail = await sendLettersMailRequest(fd);
            if (resultMail.isOk) {
                //если успешно отправили мыло
                console.log(resultMail.message);
            } else {
                console.error(resultMail.message);
            }
            //#endregion
        } else {
            if (result.message === 'Не удалось загрузить вложения!'){
                // здесь мессага все равно уходит, но без вложения. Обновляем список
                openReqPopup(false);
                setSendMessage(true);
            }
            notify(result.message, 'error', 5000);
        }
        //endregion ext
        setLoading(false)
    }

    const typeOptions = {
        dataSource: getSelectableRequestTypes(reqTypes, defaultType),
        displayExpr: "name",
        valueExpr: "id",
        value: defaultType,
        placeholder: "Выберите тип запроса на обслуживание...",
        noDataText: "Не удалось получить данные с сервера",
        disabled: disabledTypes,
        onValueChanged: async function(e) {
            setDefaultType(e.value);
            const newType = reqTypes.find(type=> type.id === e.value);
            setDefaultMessage(newType ? newType.defaultText : null);
            if (selectedDog && pointVisibleTypes.includes(e.value) && tuList.length !== 1) {
                const res = await getPointsList(selectedDog.kodDog);
                if (res.isOk) {
                    setTuList(res.data);
                    if (res.data.length > 0) setSelectedTu(res.data[0].kodPoint);
                }
                else notify(res.message, 'error',10000);
            }
        }
    }

    const messageOptions = {
        placeholder: 'Введите текст запроса...',
        showClearButton: true,
        value: parsedDefaultMessage,
        autoResizeEnabled: true
    }

    const dogovorOptions = {
        value: selectedDog ? ("№"+selectedDog.ndog+": "+selectedDog.name) : ''
    }

    const pointOptions = {
        defaultValue: selectedTu,//tuList.length === 1 ? tuList[0].kodPoint : null,
        value: selectedTu,
        dataSource: tuList,
        valueExpr: 'kodPoint',
        displayExpr: 'text',
        noDataText: 'Нет точек для отображения',
        placeholder: 'Выберите точку учета...',
        onValueChanged: async function(e) {
            setSelectedTu(e.value)
            //достанем ПУ
            const res = await getPointPus(e.value)
            if (res.isOk) {
                setPu(res.data && res.data.kodPointPu ? res.data : null)
            }
        }
    }


    return (
        <Popup
            id="req-popup"
            visible={isOpen}
            onHiding={hidingPopup}
            dragEnabled={true}
            hideOnOutsideClick={false}
            height='auto'
            width={isXSmall ? '90vw' : '80vw'}
            maxHeight={'90%'} //форма с прибором не входит никак иначе
            maxWidth="900px"
            title="Запрос на обслуживание"
            showCloseButton={true}
            titleRender={()=>PopupTitleWithIcon(faPenClip, "Новое обращение",hidingPopup)}
        >
            <ScrollView className="big-input popupWithUploader" width='100%' height='100%'>
                <form className={isXSmall ? 'px-0' : 'px-3'} onSubmit={onSendRequest}>
                    <Form labelMode={'floating'}
                          labelLocation={'top'}
                          formData={formData.current}
                          id="request-form"
                          colCount={1}
                    >
                        <Item dataField="type_request" editorType="dxSelectBox" editorOptions={typeOptions}>
                            <Label text="Тип запроса"/>
                            <RequiredRule message="Выберите тип запроса!" />
                        </Item>
                        {selectedDog && dogVisibleTypes.includes(defaultType) &&
                            <Item
                                dataField="dogovor"
                                editorType="dxTextBox"
                                disabled={true}
                                editorOptions={dogovorOptions}
                            >
                                <Label text="Выбранный договор"/>
                            </Item>
                        }
                        {selectedDog && pointVisibleTypes.includes(defaultType) &&
                            <Item
                                dataField="point"
                                editorType="dxSelectBox"
                                disabled={pointDisabled}
                                editorOptions={pointOptions}
                            >
                                <Label text="Точка учета"/>
                            </Item>
                        }
                        {selectedDog && defaultType === 5 &&
                            <GroupItem caption={pu ? 'Данные нового ПУ (взамен ПУ №'+pu.numPu+')' : 'Данные нового ПУ'}>
                                <GroupItem cssClass={'zamena-pu'} colCount={2}>
                                    <Item dataField="nom_pu" editorType="dxTextBox">
                                        <Label text={"Номер ПУ"}/>
                                        <RequiredRule message="Введите номер ПУ!" />
                                        <StringLengthRule max={100} message="Максимальная длина - 100 символов" />
                                        <PatternRule pattern=".{1,100}" message="Максимальная длина - 100 символов" />
                                    </Item>
                                    <Item dataField="name_typepu" editorType="dxTextBox">
                                        <Label text={"Тип счетчика"}/>
                                        <RequiredRule message="Введите тип счетчика!" />
                                        <StringLengthRule max={100} message="Максимальная длина - 100 символов" />
                                        <PatternRule pattern=".{1,100}" message="Максимальная длина - 100 символов" />
                                    </Item>
                                </GroupItem>
                                <GroupItem cssClass={'zamena-pu'} colCount={3}>

                                    <Item dataField="dat_s" editorType="dxDateBox" editorOptions={{type: 'datetime', useMaskBehavior: true}}>
                                        <Label text={"Дата установки"}/>
                                        <RequiredRule message="Введите дату установки!" />
                                    </Item>
                                    <Item dataField="razr1" editorType="dxNumberBox" editorOptions={{
                                        inputAttr: { maxLength: 6, pattern: '\\d*' }, // Ограничение длины ввода до 6 символов
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}>
                                        <Label text={"Разрядность целой части"}/>
                                        <RequiredRule message="Введите разрядность целой части!" />
                                        <StringLengthRule max={6} message="Максимальная длина - 6 цифр" />
                                        <PatternRule pattern="^.{1,6}$" message="Максимальная длина - 6 цифр" />
                                    </Item>
                                    <Item dataField="razr2" editorType="dxNumberBox" editorOptions={{
                                        inputAttr: { maxLength: 6, pattern: '\\d*' }, // Ограничение длины ввода до 6 символов
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}>
                                        <Label text={"Разрядность дробной части"}/>
                                        <RequiredRule message="Введите разрядность дробной части!" />
                                        <StringLengthRule max={6} message="Максимальная длина - 6 цифр" />
                                        <PatternRule pattern="^.{1,6}$" message="Максимальная длина - 6 цифр" />
                                    </Item>
                                    <Item dataField="god_vip" editorType="dxNumberBox" editorOptions={{
                                        inputAttr: { maxLength: 4, pattern: '\\d*' }, // Ограничение длины ввода 4 символов
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}>
                                        <Label text={"Год выпуска"}/>
                                        <RequiredRule message="Введите год выпуска!"/>
                                        <StringLengthRule min={4} max={4} message="Допустимо 4 цифры!"/>
                                        <RangeRule min={2001} max={new Date().getFullYear()} message={`Некорректно заполнен год: 2000 < год <= ${new Date().getFullYear()}!`}/>
                                        <PatternRule pattern="^\d{4}$" message="Максимальная длина - 4 цифр" />
                                    </Item>
                                    <Item dataField="kvartal_pp" editorType="dxSelectBox" editorOptions={{dataSource: [1,2,3,4]}}>
                                        <Label text={"Квартал последней поверки"}/>
                                        <RequiredRule message="Введите квартал последней поверки!" />
                                    </Item>
                                    <Item dataField="god_pp" editorType="dxNumberBox" editorOptions={{
                                        inputAttr: { maxLength: 4, pattern: '\\d*' }, // Ограничение длины ввода 4 20 символов
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}>
                                        <Label text={"Год последней поверки"}/>
                                        <RequiredRule message="Введите год последней поверки!" />
                                        <StringLengthRule min={4} max={4} message="Допустимо 4 цифры!"/>
                                        <RangeRule min={2001} max={new Date().getFullYear()} message={`Некорректно заполнен год: 2000 < год <= ${new Date().getFullYear()}!`}/>
                                        <PatternRule pattern="^\d{4}$" message="Максимальная длина - 4 цифр" />
                                    </Item>
                                    <Item dataField="mpi" editorType="dxNumberBox" editorOptions={{ // Ограничение длины ввода 2 цифры
                                        inputAttr: { maxLength: 2, pattern: '\\d*' },
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}>
                                        <Label text={"Межповерочный интервал"}/>
                                        <RequiredRule message="Введите межповерочный интервал!" />
                                        <StringLengthRule min={1} max={2} message="Допустимо 2 цифры!"/>
                                        <RangeRule min={1} max={99} message={`Некорректно заполнено: 0 < год <= 99!`}/>
                                        <PatternRule pattern="\d{1,2}" message="Максимальная длина - 2 цифры" />
                                    </Item>
                                    <Item dataField="dat_start_w" editorType="dxDateBox" editorOptions={{type: 'datetime', useMaskBehavior: true}}>
                                        <Label text={"Дата начала работ"}/>
                                        <RequiredRule message="Введите дату начала работ!" />
                                    </Item>
                                    <Item dataField="dat_end_w" editorType="dxDateBox" editorOptions={{type: 'datetime', useMaskBehavior: true}}>
                                        <Label text={"Дата окончания работ"}/>
                                        <RequiredRule message="Введите дату окончания работ!" />
                                    </Item>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <Item dataField="balance_name" editorType="dxTextBox">
                                        <Label text={"Балансовая принадлежность"}/>
                                        <RequiredRule message="Введите балансовую принадлежность!" />
                                        <StringLengthRule max={100} message="Максимальная длина - 100 символов" />
                                        <PatternRule pattern=".{1,100}" message="Максимальная длина - 100 символов" />
                                    </Item>
                                    <Item dataField="expl_name" editorType="dxTextBox">
                                        <Label text={"Эксплуатационная ответственность"}/>
                                        <RequiredRule message="Введите эксплуатационную ответственность!" />
                                        <StringLengthRule max={100} message="Максимальная длина - 100 символов" />
                                        <PatternRule pattern=".{1,100}" message="Максимальная длина - 100 символов" />
                                    </Item>
                                </GroupItem>
                            </GroupItem>
                        }
                        {useCompositeMessage ? (
                            <SimpleItem
                                key={`message-composite-${defaultMessage || ''}`}
                                dataField="message"
                                cssClass="message-composite-form-item"
                            >
                                <Label text="Текст запроса"/>
                                <RequiredRule message="Введите текст сообщения!" />
                                <MessageCompositeField
                                    prefix={addressChangeParts.prefix}
                                    suffix={addressChangeParts.suffix}
                                    placeholder={ADDRESS_CHANGE_HINT}
                                    value={addressChangeBody}
                                    onValueChanged={onAddressChangeBodyChanged}
                                />
                            </SimpleItem>
                        ) : (
                            <Item
                                key={`message-${defaultType}-${defaultMessage || ''}`}
                                dataField="message"
                                editorType="dxTextArea"
                                editorOptions={messageOptions}
                            >
                                <Label text="Текст запроса"/>
                                <RequiredRule message="Введите текст сообщения!" />
                            </Item>
                        )}
                        <GroupItem caption={""}>
                            <Item>
                                <ExtFileUploader typeFileLimit={typeFileLimit} ref={extFileUploaderRef} setfile={(e) => formData.current.attachments = e }></ExtFileUploader>
                            </Item>
                        </GroupItem>
                        <ButtonItem horizontalAlignment="left">
                            <ButtonOptions
                                type={'default'}
                                useSubmitBehavior={true}
                                text="Отправить"
                                icon="email"
                                disabled={loading}
                            >
                            </ButtonOptions>
                        </ButtonItem>
                    </Form>
                </form>
                <LoadIndicator width={'24px'} height={'24px'} visible={loading}/>
            </ScrollView>
        </Popup>
    )
}

export default RequestPopup
